export const ALLOCATION_ACCOUNT = {
    BASE_PATH: '/stock-and-inventory/allocation-account/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    ADD_BUTTON_TITLE: 'Add New Allocation Account',
    LIST_PAGE_TITLE: 'Allocation Account List',
    EDIT_PAGE_TITLE: 'Edit Allocation Account',
    GET_ALL: '/allocation-account',
    CREATE: '/allocation-account/create',
    UPDATE: '/allocation-account/update/',
    DELETE: '/allocation-account/delete/',
    GET_ONE : '/allocation-account/edit/'
};
